'use client';

import Link from 'next/link';
import { ArrowUpRight } from 'lucide-react';

import { Heading } from '@/components/ui/heading/heading';
import { SectionLink } from '@/components/ui/section-link/section-link';
import { AnimatedList, AnimatedListItem } from '@/components/animations';
import { URLBuilder } from '@/utils/URLBuilder';
import type { TCity } from '@/shared/types';

type TSiblingCitiesProps = {
  cities: TCity[];
  className?: string;
};

/** "Obsługujemy też" — internal-link block to sibling city pages + the hub (SEO + discovery). */
export const SiblingCities = ({ cities, className = '' }: TSiblingCitiesProps) => {
  if (!cities.length) return null;

  return (
    <section className={className} aria-label="Inne obsługiwane miasta">
      <Heading variant="h2" highlight="też" className="mb-6 text-3xl">
        Obsługujemy też inne miasta
      </Heading>

      <AnimatedList className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {cities.map((city) => (
          <AnimatedListItem key={city.slug}>
            <Link
              href={URLBuilder.paths.getCity(city.slug)}
              className="group flex items-center justify-between rounded-xl border border-neutral-800 bg-backgroundLight px-4 py-3 transition-colors hover:border-action"
            >
              <span className="font-oswald">{city.name}</span>
              <ArrowUpRight
                className="h-4 w-4 text-neutral-500 transition-colors group-hover:text-action"
                aria-hidden
              />
            </Link>
          </AnimatedListItem>
        ))}
      </AnimatedList>

      <SectionLink href={URLBuilder.paths.getCitiesHub()} label="Zobacz wszystkie miasta" className="mt-6" />
    </section>
  );
};
